<template>
  <div class="salesindex">
    <div class="position-relative">
      <div class="position-absolute mt-2 pbz-font body-md-bold">
        {{ $t('sideBar.sales') }}
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <a-input-search
          class="col-4"
          allow-clear
          size="large"
          :placeholder="$t('utils.search') + ' ' + $t('utils.search_placeholder')"
          :value="querySearch"
          :disabled="isFetching"
          @change="handleSearch"
        />
        <a-button
          size="large"
          icon="filter"
          class="ml-2"
          :disabled="isFetching"
          @click="onShowModalFilter"
        >
          {{ $t('utils.filter') }}
        </a-button>
        <a-button v-if="activeFilter.length > 1" size="large" class="ml-2" @click="resetFilter">
          {{ $t('utils.clearFilter') }}
        </a-button>
        <a-button
          type="primary"
          size="large"
          class="ml-2"
          :disabled="isFetching && $store.state.exportData.exportFileNotification"
          @click.prevent="showModalExportExcel = true"
        >
          {{ $t('warehouse.export_data') }}
        </a-button>
        <a-button
          v-if="$store.state.user.role_name === 'Super User' && $route.query.sales_state === 'SUBMITTED' && $route.query.filter_category === 'submitted'"
          type="primary"
          size="large"
          class="ml-2"
          :disabled="isFetching"
          @click="onBulkAcceptOrder"
        >
          Bulk Accept Order
        </a-button>
        <a-button
          v-if="isCanSync"
          type="secondary"
          size="large"
          class="ml-2"
          @click.prevent="showModalSyncOrderChannel = true"
        >
          <a-icon type="sync" />
          {{ $t('sales.sync_order') }}
        </a-button>
        <a-button
          v-if="$route.meta.key.includes('sales-channel-kino') && tempSales.length"
          type="primary"
          size="large"
          class="ml-2"
          :disabled="isFetching"
          @click.prevent="handleSubmitSFA"
        >
          {{ $t('sales.resend_sfa') }}
        </a-button>
      </div>
    </div>
    <div class="d-flex flex-wrap justify-content-center mt-3 categories">
      <a-tag
        v-for="item in activeFilter"
        :key="item.value"
        :closable="item.name === 'date_from' && !$route.query.date_from ? false : true"
        class="filter-tag mb-2"
        @close="removeFilter(item)"
      >
        <b>{{ $t(`sales.${item.name}`) }}:</b> {{ item.label }}
      </a-tag>
    </div>

    <div class="d-flex justify-content-between align-items-start my-3">
      <div class="flex-grow-1">
        <a-button
          v-for="item, index in categoryState"
          :key="`${item.title}-${index}`"
          shape="round"
          :disabled="isFetching || loadingCategory || activeCategories === item.title"
          :class="[
            'px-2 mb-1 mr-1',
            activeCategories === item.title && 'bg-white text-danger border-danger',
          ]"
          @click="changeCategorieState(item)"
        >
          {{ $t('order.filterState.' + item.title) }}
          <span style="margin-left: 2px">({{ total[item.title] }})</span>
        </a-button>
      </div>

      <div class="d-flex align-items-center flexno">
        <b class="mr-2">
          {{ $t('order.sortBy') }}
        </b>
        <a-select
          style="width: 120px"
          :disabled="isFetching || !salesData.length"
          :value="sort_mode"
          @change="handleChangeSort"
        >
          <a-select-option v-for="sort in SORT_OPTIONS" :key="sort.value" :value="sort.value">
            {{ $t('order.' + sort.label) }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    

    <div class="table-responsive pb-2 mt-3" :style="{ maxHeight: screenHeight }">
      <div
        class="container-fluid border rounded py-2 mx-0 mt-0"
        :style="{ minWidth: listWidth + 'px', position: 'sticky', top: 0, background: 'white', zIndex: 2 }"
      >
        <div class="row flex-nowrap row-calc">
          <div
            v-for="tr in trList"
            :key="tr"
            :class="[tr === 'orderNumber' ? orderCol : tr === 'itemTotal' ? 'col' : 'col', 'text-truncate', tr === 'checkbox' ? 'w-8' : '']"
            :style="{ fontSize: '12px', maxWidth: tr === 'itemTotal' ? '80px' : '' }"
          >
            <a-checkbox
              v-if="$route.meta.key.includes('sales-channel-kino') && tr === 'checkbox' && total_box > 0"
              :indeterminate="indeterminate"
              :checked="checked_all"
              :disabled="isFetching"
              class="sales-checkbox"
              @change="checkboxSelectAllSubmitted"
            />
            <span v-else-if="tr !== 'checkbox'">
              {{ $t('order.' + tr) }}
            </span>
          </div>
          <div class="col px-1 text-truncate" style="font-size: 12px;">
            {{ $t('sales.status') }}
          </div>
          <div class="col px-1 text-truncate" style="font-size: 12px; max-width: 80px;" />
          <div class="" style="width: 40px !important; position: sticky; right: 0; background: white;" />
        </div>
      </div>

      <LoadingListTable v-if="isFetching" class="my-2" />
      <template v-else>
        <ErrorInfo v-if="errorRows" :error-type="errorRows" />
        <template v-else>
          <template v-if="salesData.length">
            <List
              v-for="(list, index) in salesData"
              :key="list.id"
              :sales="list"
              :sales-num="index"
              :width="listWidth"
              :permission="permission"
              :order-length="orderLength"
              :temp="tempSales"
              :business-id="businessId"
              :options-priority="priorityLevelList"
              class="mt-2"
              @onLogTracking="handleLogTracking"
              @handleItemSubmitted="handleItemSubmitted"
              @handleSfaDetail="handleSfaDetail"
              @onClickCancelOrder="onClickCancelOrder"
              @onClickInternalCancelOrder="onClickInternalCancelOrder"
              @onClickAccepted="onClickAccepted"
              @onClickChannelAccept="onClickChannelAccept"
              @onOpenCollapse="onOpenCollapse"
              @onCancelRequest="onCancelRequest"
              @onHistoryOrder="handleHistoryOrder"
            />
          </template>
          <EmptyInfo
            v-else
            class="py-5"
            :title="$t('order.empty_title')"
            :description="$t('order.empty_msg')"
          />
        </template>
      </template>
    </div>
    <div class="d-flex justify-start align-items-center mt-3">
      <Pagination
        v-if="!isFetching && salesData.length"
        class="text-right ml-auto"
        :total="total_row"
        :page-size="PAGE_SIZE"
        :total-length-per-page="salesData.length"
        :default-page="currentPage"
        @changePage="changePage"
      />
    </div>

    <FilterList
      :show-modal="showModalFilter"
      :order-period="orderPeriod"
      :load-warehouse="loadWarehouse"
      :load-channel="loadChannel"
      :options-channel="options_channel"
      :options-priority="priorityLevelList"
      :business-value="businessValue"
      :sales-channel-value="salesChannelValue"
      :channel-value="channelValue"
      :warehouse-value="warehouseValue"
      :order-type-value="orderTypeValue"
      :priority-level-value="priorityLevelValue"
      :status-value="statusValue"
      :customer-value="customerValue"
      :courier-value="courierValue"
      @close="showModalFilter = false"
      @onFocusChannel="fetchChannel"
      @onBlurChannel="blurChannel"
      @onFocusWarehouse="fetchWarehouse"
      @onBlurWarehouse="onBlurWarehouse"
      @onSetList="onSetList"
      @submit="submitFilter"
    />

    <ModalConfirm
      :visible="showModalAccepted"
      :loading="loadingAccept"
      icon="check-circle"
      :title="$t('order.accept_confirm_msg')"
      :ok-label="$t('utils.yes')"
      :cancel-label="$t('utils.cancel')"
      @ok="onAcceptOrder"
      @cancel="onCloseModalAccept"
    >
      <div
        class="ant-alert ant-alert-error ant-alert-with-description ant-alert-no-icon py-2 mb-2 text-left"
      >
        <b>{{ $t('order.orderNumber') }}</b> : {{ dataAccepted.order_number }}
      </div>
    </ModalConfirm>

    <ModalCancelOrder
      ref="refModalCancelOrder"
      :visible="showModalCancelOrder"
      :loading="loadingCancelOrder"
      :data="dataCancelOrder"
      :type-cancel-modal="typeCancelModal"
      @cancel="closeModalCancelOrder"
      @ok="onSubmitCancelOrder"
    />

    <ModalInternalCancelOrder
      :visible="showModalInternalCancelOrder"
      :data="dataInternalCancelOrder"
      :loading="loadingCancelOrder"
      @cancel="closeModalInternalCancelOrder"
      @ok="onSubmitInternalCancelOrder"
    />

    <ModalExportSales
      :options-channel="options_channel"
      :visible="showModalExportExcel"
      :on-close="onCloseModalExportExcel"
      :category-state="categoryState"
      :priority-level-list="priorityLevelList"
      :warehouse-data="warehouse_list"
      :total-export-row-data="totalExportSalesData"
      @handleSubmitModal="downloadExcel($event, true)"
      @handleCheckTotalRowData="countDataSales($event, false)"
      @onResetForm="totalExportSalesData = null"
    />

    <ModalSyncOrderChannel
      :is-loading="loadingSyncOrder"
      :visible="showModalSyncOrderChannel"
      :on-close="onCloseModalSyncOrderChannel"
      @handleSubmitModal="onSyncOrderForChannel"
    />

    <a-modal
      :title="$t('sales.detail_sfa')"
      :visible="sfaInfo.visible"
      :closable="false"
      :footer="null"
      :width="450"
    >
      <a-row :gutter="16">
        <a-col :span="8">
          {{ $t('order.orderNumber') }}
        </a-col>
        <a-col :span="16">
          : {{ sfaInfo.order_number }}
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt-2">
        <a-col :span="8">
          {{ $t('sales.status') }}
        </a-col>
        <a-col :span="16">
          : {{ $t('utils.failed') }}
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt-2">
        <a-col :span="8">
          {{ $t('store_list_page.description') }}
        </a-col>
        <a-col :span="16">
          :
        </a-col>
        <a-col :span="24" class="mt-1">
          {{ sfaInfo.description }}
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt-4">
        <a-col :span="24" class="text-right">
          <a-button type="primary" ghost @click="sfaInfo.visible = false">
            {{ $t('utils.close') }}
          </a-button>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal
      v-model="showModalLog"
      :width="480"
      :closable="false"
      :title="`${$t('sales.awb_status')} ${shipmentLogTitle}`"
      centered
      class="log-modal"
    >
      <a-skeleton v-if="loadingLog" :loading="loadingLog" active />
      <template v-else>
        <div v-if="!shipmentLogList.data.length" class="text-center">
          <p class="mb-2" style="font-size: 18px">
            <b>{{ $t('sales.delivery_data_not_found') }}</b>
          </p>
          <p class="mb-0">
            {{ $t('sales.delivery_data_not_found_msg') }}
          </p>
        </div>
        <template v-else>
          <a-timeline-item v-for="(log, index) in shipmentLogList.data" :key="index" :color="`${index == 0 ? 'red' : 'gray'}`" class="log-timeline">
            <p :class="['mb-1', index == 0 ? 'log-current' : '']">
              <b>{{ $moment(parseInt(shipmentLogList.data[shipmentLogList.data.length - index - 1]?.date) * 1000).format('DD MMMM YYYY HH:mm') }}</b>
            </p>
            <p class="mb-0">
              {{ shipmentLogList.data[shipmentLogList.data.length - index - 1]?.desc }}
            </p>
            <div v-if="shipmentLogList.data[shipmentLogList.data.length - index - 1]?.status === 'E_DELIVERED'" class="mt-2">
              <a-avatar
                v-for="(img, idx) in shipmentLogList.images"
                :key="idx"
                :src="img.url"
                :size="60"
                shape="square"
                class="mr-2"
                style="cursor: pointer"
                @click="onOpenImage(img.url)"
              />
            </div>
          </a-timeline-item>
        </template>
      </template>
      <template slot="footer">
        <div class="text-right">
          <a-button type="primary" @click="showModalLog = false; shipmentLogTitle = ''">
            OK
          </a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      v-model="showModalTiktokError"
      :title="$t('utils.failed')"
      :footer="null"
      centered
    >
      <div class="text-center py-4">
        <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#ff4d4f" style="font-size: 48px;" />
        <div class="mt-4 pbz-font body-md-regular">
          {{ tiktokErrorMessage }}
        </div>
      </div>
      <div class="text-right mt-4">
        <a-button type="primary" @click="showModalTiktokError = false">
          {{ $t('utils.close') }}
        </a-button>
      </div>
    </a-modal>

    <a-modal
      v-model="showModalTiktokShipmentDelay"
      :closable="false"
      :mask-closable="false"
      centered
    >
      <template slot="title">
        <strong>{{ $t('order.channel_accept_shipment_delay_title') }}</strong>
      </template>
      <p class="mb-0">
        {{ $t('order.channel_accept_shipment_delay_description') }}
        <strong>{{ $t('order.channel_accept_shipment_delay_retry', { retry_at: tiktokShipmentRetryTime }) }}</strong>
      </p>
      <template slot="footer">
        <a-button type="primary" @click="showModalTiktokShipmentDelay = false">
          {{ $t('utils.close') }}
        </a-button>
      </template>
    </a-modal>

    <DrawerOrderHistory
      :visible="showDrawerOrderHistory"
      :order-data="selectedOrderHistory"
      :business-id="businessId"
      @close="showDrawerOrderHistory = false"
    />
  </div>
</template>

<script>
import { getShipmentLog } from '@/api/shipping'
import { getAllWarehouseList } from '@/api/warehouse'
import { getSalesView, getSalesTotal } from '@/api/sales'
import { getKinoSfa, resendKinoSfa } from '@/api/sfa'
import { onSyncOrderChannel,
  checkStatusSyncOrderChannel,
  processingOrder,
  processingOrderState,
  cancelOrderState,
  internalCancelOrderState,
  b2cProcessingOrderCancel,
} from '@/api/channels/index'
import { countSales, downloadSalestoExportHistory, checkRequestExportSales } from '@/api/dashboard'
import { channelAcceptTiktok } from '@/api/channels/tiktok'
import { channelAcceptShopee } from '@/api/channels/shopee'

import FilterList from '@/components/Sales/Form/Filter/index-v3.vue'
import List from '@/components/Sales/List/index.vue'
import ModalConfirm from '@/components/Modal/ModalConfirm.vue'
import ModalCancelOrder from '@/components/Sales/Modal/ModalCancelOrder'
import ModalInternalCancelOrder from '@/components/Sales/Modal/ModalInternalCancelOrder'
import Pagination from '@/components/Pagination/index.vue'
import LoadingListTable from '@/components/Loading/ListTable'
import ErrorInfo from '@/components/ErrorInfo'
import EmptyInfo from '@/components/EmptyInfo'
import debounce from 'lodash/debounce'
import ChannelsConstants from '@/constants/channels'
import ModalExportSales from '@/views/sales/ModalExportSales.vue'
import ModalSyncOrderChannel from '@/views/sales/ModalSyncOrderChannel.vue'
import DrawerOrderHistory from '@/components/Sales/Drawer/DrawerOrderHistory.vue'
import isEqual from 'lodash/isEqual'
import {
  rejectTiktokCancelOrReturnOrder,
  acceptTiktokCancelOrReturnOrder,
  cancelTiktokOrder,
} from '@/api/channels/tiktok'

const setTableWidth = () => {
  const { width } = window.screen
  return width < 821 ? 1190 : width - 343
}

export default {
  components: {
    FilterList,
    List,
    ModalConfirm,
    ModalCancelOrder,
    ModalInternalCancelOrder,
    LoadingListTable,
    EmptyInfo,
    ErrorInfo,
    Pagination,
    
    ModalExportSales,
    ModalSyncOrderChannel,
    DrawerOrderHistory,
  },
  data() {
    return {
      SORT_OPTIONS: [
        { value: 'DESC', label: 'sortByNewest' },
        { value: 'ASC', label: 'sortByOldest' },
      ],
      categoryState: [
        { value: 'all', title: 'all' },
        { value: 'VERIFIED', title: 'verified' },
        { value: 'SUBMITTED', title: 'submitted' }, 
        { value: 'CANCELREQUESTED,CANCEL_REQUESTED', title: 'cancelrequested' },
        { value: 'ACCEPTED', title: 'onprocess', shipping_states: 'CREATED,BOOKED' },
        { value: 'ACCEPTED', title: 'shipped', shipping_states: 'SHIPPED' }, 
        { value: 'ACCEPTED', title: 'send', shipping_states: 'DELIVERED' }, 
        { value: 'COMPLETED', title: 'completed' },
        { value: 'CANCELED,CANCELEDPAYMENTEXPIRED,REJECTED', title: 'canceled' }, 
      ],
      priorityLevelList: [
        { value: 'all', label: this.$t('order.all_priority_level') },
        { value: '50', label: 'Instant Priority' },
        { value: '100', label: 'Instant' },
        { value: '200', label: 'Sameday 8 Hours' },
        { value: '300', label: 'Sameday' },
        { value: '400', label: 'Next Day Delivery' },
        { value: '500', label: 'Express' },
        { value: '600', label: 'Standard' },
        { value: '700', label: 'Economy' },
        { value: '800', label: 'Cargo' },
      ],
      PAGE_SIZE: 20,
      total: {
        all: 0,
        verified: 0,
        submitted: 0,
        cancelrequested: 0,
        onprocess: 0,
        shipped: 0,
        send: 0,
        completed: 0,
        canceled: 0,
      },
      salesStateList: ['verified', 'submitted', 'cancelrequested', 'onprocess', 'shipped', 'send', 'completed', 'canceled'],
      total_row: 0,
      total_box: 0,
      orderLength: 0,
      showModalFilter: false,
      id: [],
      warehouse_list: [],
      querySearch: '',
      errorRows: false,
      salesData: [],
      tempSales: [],
      loadingList: true,
      loadingCategory: true,
      loadChannel: true,
      loadWarehouse: true,
      customerValue: '',
      courierValue: '',
      businessValue: [],
      salesChannelValue: [],
      channelValue: [],
      warehouseValue: [],
      orderTypeValue: 'ALL',
      priorityLevelValue: [],
      statusValue: 'all',
      orderPeriod: ['', ''],
      showModalCancelOrder: false,
      showModalInternalCancelOrder: false,
      loadingCancelOrder: false,
      dataCancelOrder: {},
      dataAccepted: {},
      dataInternalCancelOrder: {},
      showModalAccepted: false,
      loadingAccept: false,
      controller: null,
      controllerTotal: null,
      listWidth: setTableWidth(),
      showModalExportExcel: false,
      loadingExport: false,
      indeterminate: false,
      checked_all: false,
      sfaInfo: {
        visible: false,
        order_number: '',
        description: '',
      },
      totalExportSalesData: null,
      showModalSyncOrderChannel: false,
      loadingSyncOrder: false,
      salesChannelList: [],
      channelList: [],
      warehouseList: [],
      mappingWarehouseList: [],
      loadingLog: false,
      showModalLog: false,
      shipmentLogTitle: '',
      shipmentLogList: {
        data: [],
        images: [],
      },
      typeCancelModal: '',
      channels: ['blibli_id', 'lazada_id', 'shopee_id', 'tokopedia_id', 'tiktok', 'tiktok_id'],
      showModalTiktokError: false,
      tiktokErrorMessage: '',
      showModalTiktokShipmentDelay: false,
      tiktokShipmentRetryTime: '',
      showDrawerOrderHistory: false,
      selectedOrderHistory: null,
    }
  },
  computed: {
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    trList() {
      const tr = ['orderDate', 'orderNumber', 'orderType', 'priorityLevel', 'business', 'channel', 'storeName', 'customer', 'itemTotal', 'priceTotal']
      return this.$route.meta.key.includes('sales-channel-kino')
        ? ['checkbox'].concat(tr)
        : tr
    },
    locale() {
      return this.$store.state?.settings?.locale || 'id-ID'
    },
    channel() {
      return this.$store.state.channel
    },
    currentPage() {
      return +this.$route.query.page || 1
    },
    sort_mode() {
      return this.$route.query.sort_mode || 'DESC'
    },
    activeCategories() {
      const query = this.$route.query
      const salesState = query.filter_category 
      if (!salesState) return 'all'
      return this.categoryState.find(item => item.title === salesState)?.title || 'all'
    },
    options_channel() {
      const listChannels = []
      this.$store.state.business.listChannels.forEach(item => {
        if (item.status?.toLowerCase() === 'connected') {
          listChannels.push({
            value: String(item.id),
            label: item.title,
            channelId:  item.sales_channel.id,
            channelCode: item.sales_channel.code,
            channelName: item.sales_channel.name,
          })
        }
      })
      return listChannels
    },
    activeFilter() {
      let result = []
      const { date_from, date_until, channel_id, warehouse_id, business_id_sales, order_type, priority_level, status, customer_name, courier_name } = this.$route.query
      const dateFormat = 'DD MMM YYYY HH:mm:ss'

      if (date_from !== 'all' && date_until !== 'all') {
        const date = date_from && date_until
          ? this.$moment(date_from).format(dateFormat) + ' - ' + this.$moment(date_until).format(dateFormat)
          : this.$moment(this.orderPeriod[0]).format(dateFormat) + ' - ' + this.$moment(this.orderPeriod[1]).format(dateFormat)
        
        result.push({
          value: date,
          label: date,
          name: 'date_from',
        })
      }

      if(business_id_sales) {
        const businessParam = business_id_sales.split(',')
        businessParam.forEach(business => {
          const findBusiness = this.$store.state.user.businessList.find(item => {
            return item.business_id !== 'all' && item.business_id == business
          })
          if(findBusiness?.business_id) {
            result.push({
              value: findBusiness.business_id,
              label: findBusiness.business_name || findBusiness.name,
              name: 'business_id_sales',
            })
          }
        })
      }

      if (this.$route.path === '/sales' && channel_id) {
        const channelIds = channel_id.split(',')
        channelIds.forEach(channel => {
          const findChannelByChannelId = this.channelList.find(item => item.value == channel)
          if (findChannelByChannelId?.value) {
            result.push({
              value: findChannelByChannelId.value,
              label: `${findChannelByChannelId.label} (${findChannelByChannelId.channelName})`,
              name: 'sales_channel_id',
            })
          }
        })
      }

      if (this.$store.state.user.restriction_base !== 'Warehouse' && warehouse_id) {
        const warehouseParam = warehouse_id.split(',')
        const list = this.$route.path === '/sales'
          ? this.warehouseList
          : this.warehouse_list
        warehouseParam.forEach(warehouse => {
          const findWarehouse = list.find(item => item?.id === warehouse || item?.value === warehouse)
          if(findWarehouse?.id || findWarehouse?.value) {
            result.push({
              value: findWarehouse?.id || findWarehouse?.value,
              label: findWarehouse?.name || findWarehouse?.label,
              name: 'warehouse_id',
            })
          }
        })
      }

      if(order_type) {
        result.push({
          value: order_type,
          label: order_type.charAt(0).toUpperCase() + order_type.slice(1),
          name: 'order_type',
        })
      }

      if(priority_level) {
        const priorityLevelParam = priority_level.split(',')
        priorityLevelParam.forEach(priority => {
          const findPriority = this.priorityLevelList.find(item => {
            return item.value !== 'all' && item.value == priority
          })
          if(findPriority?.value) {
            result.push({
              value: findPriority.value,
              label: findPriority.label,
              name: 'priority_level',
            })
          }
        })
      }

      if(status) {
        result.push({
          value: status,
          label: status.charAt(0).toUpperCase() + status.slice(1),
          name: 'status',
        })
      }

      if(customer_name) {
        result.push({
          value: customer_name,
          label: customer_name,
          name: 'customer_name',
        })
      }

      if(courier_name) {
        result.push({
          value: courier_name,
          label: courier_name,
          name: 'courier_name',
        })
      }
      
      return result
    },
    getUserData() {
      return this.$store.state?.user || {}
    },
    dataWarehouse() {
      return this.$store.state?.warehouse?.warehouse?.data || []
    },
    screenHeight() {
      return 'calc(100vh - 350px)'
    },
    permission() {
      let key = this.$route.meta.key
      if(this.$route.meta.key.includes('-:id')) key = key.replace('-:id', '')
      return this.$store.getters['user/can'](key)
    },
    isFetching() {
      return !this.$store.state.business.fetchingChannelList && !this.loadingList ? false : true
    },
    allChannelList() {
      return this.$route.query.business_id && this.$store.state.business.listChannels.length
        ? this.$store.state.business.listChannels
        : this.$store.state.business.channelList
    },
    listChannels() {
      const channel = this.$store.state.business.listChannels.find(item => item.sales_channel?.code === 'distributor_redeem')
      return channel
    },
    orderCol() {
      return 'col'
      
      
      
      
      
    },
    isCanSync() {
      const findTiktokTokped = this.$store.state.business.listChannels.find(channel => channel.id == this.$route.params?.id)
      return findTiktokTokped?.notes !== 'tiktok_tokopedia' && ['shopee_id', 'tokopedia_id', 'lazada_id'].includes(this.$route.query?.channel_code)
    },
  },
  watch: {
    '$route.query'() {
      this.getData()
    },
    '$route.query.workspace_id'() {
      this.warehouse_list = []
      this.loadChannel = true
      this.loadWarehouse = true
      this.fetchChannel()
      this.fetchWarehouse()
    },
    '$route.query.channel_code'() {
      this.resetFilter()
    },
    businessId() {
      this.warehouse_list = []
      this.loadChannel = true
      this.loadWarehouse = true
      this.getData()
      this.fetchChannel()
      this.fetchWarehouse()
    },
    allChannelList() {
      this.getData()
    },
    listChannels() {
      this.getData()
    },
    '$route.params.id': {
      immediate: true,
      handler(value) {
        if (
          this.channels.includes(this.$route.query.channel_code) &&
          this.$store.state.user.restriction_base === 'Warehouse'
        ) {
          this.getWarehouseChannelList()
        }
      },
    },
  },
  mounted() {
    if (
      this.$store.state.user.restriction_base === 'Warehouse' &&
      this.channels.includes(this.$route.query.channel_code)
    ) {
      this.getWarehouseChannelList()
    }
    this.getData()
    this.fetchWarehouse()
    this.fetchChannel()
  },
  beforeDestroy() {
    if (this.controller) {
      this.controller.abort()
      this.controller = null
    }
    if (this.controllerTotal) {
      this.controllerTotal.abort()
      this.controllerTotal = null
    }
  },
  methods: {
    async onBulkAcceptOrder() {
      let business_id = this.$route.query.business_id
      if (!business_id) {
        business_id = this.$store.state.user?.businessList?.find(
          val => val.warehouse_id === this.$route.query?.warehouse_id,
        )?.business_id
      }

      this.loadingAccept = true
      const promises = []
      this.salesData.forEach(sales => {
        const channel_code = sales?.channel?.code || sales?.channel?.channel_code
        if (ChannelsConstants.includes(channel_code)) {
          promises.push(
            processingOrder({
              business_id: sales?.business?.business_id || business_id || this.businessId,
              processType: 'state',
              id: sales.id,
              channel_id: sales?.channel?.id,
              channel_code: channel_code === 'distributor_redeem'
                ? 'distributor'
                : channel_code,
              new_status: 'ACCEPTED',
              order_number: sales.order_number,
            }),
          )
        } else {
          promises.push(
            processingOrderState({
              business_id: sales?.business?.business_id || business_id || this.businessId,
              order_id: sales.id,
              order_number: sales.order_number,
              data: {
                new_status: 'ACCEPTED',
                reason_code: '',
                reason: '',
                oos_line_item_ids: [],
                channel: {
                  id: sales?.channel?.id,
                  code: sales?.channel?.code,
                },
              },
            }),
          )
        }
      })

      if (promises.length) {
        await Promise.allSettled(promises)
          .then(() => this.$message.success(res?.data?.message || 'Successfully updated state'))
          .catch(() => this.$message.error(err?.response?.data?.message || err.message))
          .finally(() => {
            this.loadingAccept = false
            this.getData()
          })
      } else {
        this.loadingAccept = false
      }
    },
    async getWarehouseChannelList() {
      this.mappingWarehouseList = []
      try {
        const normalized = await this.$store.dispatch('warehouse/GETWAREHOUSECHANNELLISTV2', {
          business_id: this.businessId,
          channel_id: this.$route.params.id,
          channel_code: this.$route.query.channel_code,
        })
        this.mappingWarehouseList = normalized
      } catch (err) {
        console.error(err)
        this.mappingWarehouseList = []
      }
    },
    handleHistoryOrder(sales) {
      this.selectedOrderHistory = sales
      this.showDrawerOrderHistory = true
    },
    async handleLogTracking(value) {
      const { channel_id, courier, awb_no } = value
      this.shipmentLogTitle = awb_no
      this.loadingLog = true
      this.showModalLog = true
      const params = {
        channel_id,
        courier: courier?.toLowerCase(),
        awb_no,
      }
      await Promise.allSettled([getShipmentLog(params), getShipmentLog(params, '/attachments')])
      .then(([{ value: { data: { data: response } } }, { value: { data: { data: res } } }]) => {
        this.shipmentLogList = {
          data: response?.[0]?.status || [],
          images: res?.[0]?.attachments?.filter(img => img.attachment_type === 'photo') || [],
        }
      })
      .catch(() => this.shipmentLogList = { data: [], images: [] })
      .finally(() => this.loadingLog = false)
    },
    onOpenImage(url) {
      window.open(url, '_blank')
    },
    textDiscountFrom(data) {
      if (data === 'channel') {
        return this.sales?.channel?.sales_channel?.name || this.$t('sales.channel')
      } else if (data === 'seller'){
        return this.sales?.business?.business_title || this.$t('sales.seller')
      }
      return data
    },
    wordingSalesState(sales_state) {
      if (!sales_state) {
        return null
      }
      switch (sales_state.toLowerCase()) {
        case 'verified':
          return 'verified'
        case 'submitted':
        case 'created':
          return 'new'
        case 'accepted':
          return 'onprocess'
        case 'shipped':
          return 'shipped'
        case 'delivered':
          return 'send'
        case 'completed':
          return 'completed'
        case 'canceled':
        case 'cancelled':
        case 'rejected':
        case 'canceledpaymentexpired':
          return 'canceled'
        case 'cancelrequested':
        case 'cancel_requested':
          return 'cancelrequested'
        default:
          return null
      }
    },
    async countDataSales(data, isExport) {
      this.totalExportSalesData = null
      await countSales({
        workspace_id: this.$route.query.workspace_id,
        business_id: this.$route.query.business_id ? this.$route.query.business_id : data.business,
        channel_id: data.channel,
        sales_channel_id: data.sales_channel,
        warehouse_id: data.warehouse,
        currency_code: data.currency,
        priority_level: data.priority_level,
        date_from: this.$moment(data.date[0]).add(7, 'hours').toISOString(),
        date_until: this.$moment(data.date[1]).add(7, 'hours').toISOString(),
        sales_state: data.shipping === 'shipped'
          ? 'SHIPPED'
          : data.shipping === 'send'
          ? 'BUYER_ACCEPTED,DELIVERED'
          : data.status,
      })
      .then(response => this.totalExportSalesData = +response?.data || 0)
      .catch(error => {
        console.error(error)
        if(error.response.data.data === null) {
          this.$notification.error({
            message: 'Data Kosong',
            description: 'Tidak ada data berdasarkan filter tersebut.',
          })
        }
      })
    },
    async downloadExcel(data, isExport, page = 0) {
      this.showModalExportExcel = false
      this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
        showModalExportSales: true,
        loadingExport: true,
        exportFileNotification: false,
      })

      const payload = {
        workspace_id: this.$route.query.workspace_id,
        business_id: this.$route.query.business_id ? this.$route.query.business_id : data.business,
        channel_id: data.channel,
        sales_channel_id: data.sales_channel,
        warehouse_id: data.warehouse,
        currency_code: data.currency,
        priority_level: data.priority_level,
        date_from: this.$moment(data.date[0]).add(7, 'hours').toISOString(),
        date_until: this.$moment(data.date[1]).add(7, 'hours').toISOString(),
        sales_state:
          data.shipping === 'shipped'
            ? 'SHIPPED'
            : data.shipping === 'send'
              ? 'BUYER_ACCEPTED,DELIVERED'
              : data.status,
        report_type: data.report_type,
      }

      await downloadSalestoExportHistory(payload)

      
      
      
      
      

      this.$router.push({
        path: '/export-history',
        query: this.$route.query,
      })
      .then(() => {
        this.$store.commit('settings/CHANGE_SETTING', {
          setting: 'selectedMenu',
          value: ['export-history'],
        })
      })
    },
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    onErrorExportSales() {
      this.totalExportSalesData = null
      this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
        exportFileNotification: false,
        showModalExportSales: false,
        loadingExport: false,
      })
      this.$notification.error({
        message: 'Proses export gagal',
        description: 'Data melebihi kapasitas server, silahkan pilih tanggal kembali',
      })
    },
    goToExportHistory(form) {
      this.showModalExportExcel = false

      this.$store.commit('exportData/SET_STATE_EXPORT_DATA', {
        showModalExportSales: false,
        loadingExport: false,
        exportFileNotification: false,
      })

      const query = {
        workspace_id: this.$route.query.workspace_id,
        business_id: this.$route.query.business_id ? this.$route.query.business_id : form.business,
        sales_channel_id: form.sales_channel,
        channel: form.channel,
        warehouse_id: form.warehouse,
        currency_code: form.currency,
        date_from: this.$moment(form.date[0]).add(7, 'hours').toISOString(),
        date_until: this.$moment(form.date[1]).add(7, 'hours').toISOString(),
        sales_state:
          form.shipping === 'shipped'
            ? 'SHIPPED'
            : form.shipping === 'send'
              ? 'BUYER_ACCEPTED,DELIVERED'
              : form.status,
        report_type: form.report_type,
      }

      this.$router.push({ path: '/export-history', query })
    },
    onCloseModalExportExcel() {
      this.showModalExportExcel = false
      this.totalExportSalesData = null
    },
    onCloseModalSyncOrderChannel() {
      this.showModalSyncOrderChannel = false
    },
    onClickAccepted(val) {
      this.dataAccepted = val
      this.showModalAccepted = true
    },
    async onClickChannelAccept(sales) {
      const channelCode = sales?.channel?.code || ''
      const channelAcceptMap = {
        tiktok: channelAcceptTiktok,
        tiktok_id: channelAcceptTiktok,
        tiktok_tokopedia: channelAcceptTiktok,
        shopee: channelAcceptShopee,
        shopee_id: channelAcceptShopee,
      }
      const channelAcceptFn = channelAcceptMap[channelCode]
      if (!channelAcceptFn) {
        this.$message.info(this.$t('order.channel_accept_not_available'))
        return
      }
      try {
        await channelAcceptFn({
          params: {
            id: sales.id,
            channel_id: sales?.channel?.id,
          },
        })
        this.$message.success(this.$t('order.channel_accept_success', { order_number: sales.order_number }))
        this.getData()
      } catch (error) {
        const rawMsg = error?.response?.data?.message || ''
        const isTiktokShipmentDelay = ['tiktok', 'tiktok_id', 'tiktok_tokopedia'].includes(channelCode) &&
          rawMsg.toLowerCase().includes('out_of_acceptance_window')
        if (isTiktokShipmentDelay) {
          this.tiktokShipmentRetryTime = this.getTiktokShipmentRetryTime(rawMsg)
          this.showModalTiktokShipmentDelay = true
          return
        }
        const friendlyMsg = rawMsg.toLowerCase().includes('already accepted')
          ? this.$t('order.channel_accept_already_accepted', { order_number: sales.order_number })
          : rawMsg || this.$t('order.channel_accept_failed', { order_number: sales.order_number })
        this.$message.error(friendlyMsg)
      }
    },
    getTiktokShipmentRetryTime(message) {
      const retryAt = message.match(/next arrange shipment:\s*([^\s]+)/i)?.[1]
      if (!retryAt) return ''

      const normalizedRetryAt = retryAt.replace(/(\.\d{3})\d+(?=(?:Z|[+-]\d{2}:?\d{2})$)/, '$1')
      const retryDate = new Date(normalizedRetryAt)
      if (Number.isNaN(retryDate.getTime())) return ''

      const timeParts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Jakarta',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(retryDate)
      const hour = timeParts.find(part => part.type === 'hour')?.value
      const minute = timeParts.find(part => part.type === 'minute')?.value
      const dateParts = new Intl.DateTimeFormat(this.$i18n.locale, {
        timeZone: 'Asia/Jakarta',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).formatToParts(retryDate)
      const day = dateParts.find(part => part.type === 'day')?.value
      const month = dateParts.find(part => part.type === 'month')?.value
      const year = dateParts.find(part => part.type === 'year')?.value

      return day && month && year && hour && minute
        ? `${day} ${month} ${year} pukul ${hour}:${minute} WIB`
        : ''
    },
    async onAcceptOrder() {
      let business_id = this.$route.query.business_id
      if (!business_id) {
        business_id = this.$store.state.user?.businessList?.find(
          val => val.warehouse_id === this.$route.query?.warehouse_id,
        )?.business_id
      }

      this.loadingAccept = true
      const channel_code = this.dataAccepted.channel?.code || this.dataAccepted.channel?.channel_code
      if (ChannelsConstants.includes(channel_code)) {
        await processingOrder({
          business_id: this.dataAccepted.business.business_id || business_id || this.businessId,
          processType: 'state',
          id: this.dataAccepted.id,
          channel_id: this.dataAccepted.channel?.id,
          channel_code: channel_code === 'distributor_redeem'
            ? 'distributor'
            : channel_code,
          new_status: 'ACCEPTED',
          order_number: this.dataAccepted.order_number,
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.onCloseModalAccept()
          this.getData()
        })
        .catch(err => {
          if (['tiktok', 'tiktok_id', 'tiktok_tokopedia'].includes(channel_code) && err?.response?.data?.message) {
            this.onCloseModalAccept()
            this.tiktokErrorMessage = err.response.data.message
            this.showModalTiktokError = true
          } else {
            this.$message.error(err?.response?.data?.message || err.message)
          }
        })
        .finally(() => {
          this.loadingAccept = false
        })
      } else {
        await processingOrderState({
          business_id: this.dataAccepted.business.business_id || business_id || this.businessId,
          order_id: this.dataAccepted.id,
          order_number: this.dataAccepted.order_number,
          data: {
            new_status: 'ACCEPTED',
            reason_code: '',
            reason: '',
            oos_line_item_ids: [],
            channel: {
              id: this.dataAccepted.channel?.id,
              code: this.dataAccepted.channel?.code,
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.onCloseModalAccept()
          this.getData()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingAccept = false
        })
      }
    },
    onCloseModalAccept() {
      this.showModalAccepted = false
      this.dataAccepted = {}
    },
    onClickCancelOrder(val) {
      this.dataCancelOrder = val
      this.showModalCancelOrder = true
      if (['tiktok', 'tiktok_id'].includes(val.channel?.code)) {
        if (['CANCELREQUESTED', 'CANCEL_REQUESTED'].includes(val.sales_state)) {
          this.typeCancelModal = 'accept'
        } else {
          this.typeCancelModal = 'cancelorder'
        }
      }
    },
    onClickInternalCancelOrder(val) {
      this.dataInternalCancelOrder = val
      this.showModalInternalCancelOrder = true
    },
    async onCancelRequest(val) {
      this.loadingList = true
      this.loadingCategory = true
      if (ChannelsConstants.includes(val.channel?.code)) {
        if (['tiktok', 'tiktok_id'].includes(val.channel?.code)) {
          this.dataCancelOrder = val
          this.showModalCancelOrder = true
          this.typeCancelModal = 'reject'
          this.loadingList = false
          this.loadingCategory = false
        } else {
          await processingOrder({
            business_id: val.business.business_id || this.$route.query.business_id || this.businessId,
            processType: 'reject-cancellation-request',
            id: val.id,
            channel_code: val.channel?.code === 'distributor_redeem'
              ? 'distributor'
              : val.channel?.code,
            new_status: 'CANCELED', 
            order_number: val.order_number,
          })
          .then(res => {
            this.$message.success(res?.data?.message || 'Successfully reject cancellation')
            this.getData()
          })
          .catch(err => {
            this.$message.error(err?.response?.data?.message || err.message)
          })
          .finally(() => {
            this.loadingList = false
            this.loadingCategory = false
          })
        }
      } else {
        await processingOrderState({
          business_id: val.business.business_id || this.$route.query.business_id || this.businessId,
          order_id: val.id,
          order_number: val.order_number,
          data: {
            new_status: 'CANCELED',
            reason_code: '',
            reason: '',
            oos_line_item_ids: [],
            channel: {
              id: this.dataAccepted.channel?.id,
              code: this.dataAccepted.channel?.code,
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.onCloseModalAccept()
          this.getData()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingAccept = false
        })
      }
    },
    async handleTiktokStateCancelOrder(values) {
      try {
        const { params, data } = values
        await cancelTiktokOrder({
          business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
          params,
          data,
        })
        this.$notification.success({
          message: 'Berhasil memproses pembatalan',
        })
        this.closeModalCancelOrder()
        this.getData()
      } catch (error) {
        console.error(error)
        this.$notification.error({
          message: 'Terjadi kesalahan',
          description: error?.response?.data?.message || 'Gagal menyetujui pembatalan',
        })
      } finally {
        this.loadingCancelOrder = false
      }
    },
    async handleTiktokAcceptCancelOrder({ order_id, cancel_id }) {
      try {
        await acceptTiktokCancelOrReturnOrder({
          business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
          order_id: order_id,
          cancel_id: cancel_id,
        })
        this.$notification.success({
          message: 'Berhasil menyetujui pembatalan',
        })
        this.closeModalCancelOrder()
        this.getData()
      } catch (error) {
        console.error(error)
        this.$notification.error({
          message: 'Terjadi kesalahan',
          description: error?.response?.data?.message || 'Gagal menyetujui pembatalan',
        })
      } finally {
        this.loadingCancelOrder = false
      }
    },
    async handleTiktokRejectCancelOrder({ order_id, cancel_id, data }) {
      try {
        await rejectTiktokCancelOrReturnOrder({
          business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
          order_id,
          cancel_id,
          data,
        })
        this.$notification.success({
          message: 'Berhasil menolak pembatalan',
        })
        this.closeModalCancelOrder()
        this.getData()
      } catch (error) {
        console.error(error)
        this.$notification.error({
          message: 'Terjadi kesalahan',
          description: error?.response?.data?.message || 'Gagal menolak pembatalan',
        })
      } finally {
        this.loadingCancelOrder = false
      }
    },
    async onSubmitCancelOrder(values) {
      this.loadingCancelOrder = true
      const { index_reason_code, ...restValues } = values
      if (ChannelsConstants.includes(this.dataCancelOrder.channel?.code)) {
        if (['tiktok', 'tiktok_id'].includes(this.dataCancelOrder.channel?.code)) {
          if (this.typeCancelModal === 'accept') {
            const { order_id, cancel_id } = values
            this.handleTiktokAcceptCancelOrder({
              order_id,
              cancel_id,
            })
          } else if (this.typeCancelModal === 'reject') {
            const { order_id, cancel_id, data } = values
            this.handleTiktokRejectCancelOrder({
              order_id,
              cancel_id,
              data,
            })
          } else if (this.typeCancelModal === 'cancelorder') {
            this.handleTiktokStateCancelOrder(values)
          } else {
            this.loadingCancelOrder = false
            return this.$notification.error({
              message: 'Terjadi kesalahan',
              description: 'Tipe cancel tidak dikenali',
            })
          }
        } else {
          await processingOrder({
            business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
            processType: 'cancel',
            id: this.dataCancelOrder.id,
            channel_code: this.dataCancelOrder.channel?.code === 'distributor_redeem'
              ? 'distributor'
              : this.dataCancelOrder.channel?.code,
            new_status: 'CANCELED', 
            order_number: this.dataCancelOrder.order_number,
            channel_id: this.dataCancelOrder?.channel?.id,
            ...values,
          })
          .then(res => {
            this.$message.success(res?.data?.message || 'Successfully cancel order')
            this.closeModalCancelOrder()
            this.getData()
          })
          .catch(err => {
            this.$message.error(err?.response?.data?.message || err.message)
          })
          .finally(() => {
            this.loadingCancelOrder = false
          })
        }
      } else if (['store'].includes(this.dataCancelOrder.channel?.code)) {
        await b2cProcessingOrderCancel({
          business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
          data: {
            reason: values?.reason || '-',
          },
          params: {
            id: this.dataCancelOrder.id,
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully cancel order')
          this.closeModalCancelOrder()
          this.getData()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
      } else if (this.$store.state.user?.listChannelOffline?.includes(this.dataCancelOrder.channel?.code)) {
        cancelOrderState({
          business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id,
          order_id: this.dataCancelOrder.id,
          order_number: this.dataCancelOrder.order_number,
          data: {
            new_status: 'CANCELED',
            reason_code: index_reason_code,
            reason: values?.reason,
            channel: {
              id: this.dataCancelOrder?.channel?.id,
              code: this.dataCancelOrder?.channel?.code,
              name: this.dataCancelOrder?.channel?.name,
              sales_channel_id: this.dataCancelOrder?.channel?.sales_channel?.id,
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.closeModalCancelOrder()
          this.getData()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
      } else {
        await processingOrderState({
          business_id: this.dataCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
          order_id: this.dataCancelOrder.id,
          order_number: this.dataCancelOrder.order_number,
          data: {
            new_status: 'CANCELED',
            reason_code: '',
            reason: '',
            oos_line_item_ids: [],
            channel: {
              id: this.dataAccepted.channel?.id,
              code: this.dataAccepted.channel?.code,
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.closeModalCancelOrder()
          this.getData()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
      }
    },
    onSubmitInternalCancelOrder(values) {
      this.loadingCancelOrder = true
      internalCancelOrderState({
        data: [values],
        business_id: this.dataInternalCancelOrder.business.business_id || this.$route.query.business_id || this.businessId,
      })
        .then(({ data }) => {
          if (data?.success?.length > 0) {
            this.$notification.success({
              message: 'Berhasil',
              description: 'Order berhasil dibatalkan',
            })
          }
          if (data?.failed?.length > 0) {
            this.$notification.success({
              message: 'Gagal',
              description: 'Terjadi kesalahan, gagal membatalkan order',
            })
          }
          this.closeModalInternalCancelOrder()
          this.getData()
        })
        .catch(err => {
          this.$notification.success({
            message: 'Gagal',
            description: 'Terjadi kesalahan, gagal membatalkan order',
          })
          console.error(err)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
    },
    closeModalCancelOrder() {
      this.showModalCancelOrder = false
      this.dataCancelOrder = {}
      this.typeCancelModal = ''
    },
    closeModalInternalCancelOrder() {
      this.showModalInternalCancelOrder = false
      this.dataInternalCancelOrder = {}
    },
    setDefaultOrderPeriod() {
      return [this.$moment().subtract(30, 'days').startOf('day').format(), this.$moment().endOf('day').format()]
    },
    handleChangeSort(sort_mode) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$router.push({ query: { ...this.$route.query, sort_mode } })
      }, 500)
    },
    handleSearch(e) {
      const value = e.target.value
      this.querySearch = value
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        const { path, query } = this.$route
        const { workspace_id, business_id, sales_channel_id, ...rest } = query
        const valTrim = value.trim()
        const defaultPeriod = this.setDefaultOrderPeriod()
        this.$router.push({
          query: {
            ...rest,
            workspace_id,
            business_id: business_id || this.businessId,
            
            sales_channel_id:
              path?.startsWith('/sales-channel') && sales_channel_id ? sales_channel_id : undefined,
            page: undefined,
            q: valTrim.length ? valTrim : undefined,
            date_from: valTrim.length ? 'all' : this.$moment(defaultPeriod[0]).format(),
            date_until: valTrim.length ? 'all' : this.$moment(defaultPeriod[1]).format(),
          },
        })
      }, 1000)
    },
    submitFilter(value) {
      this.showModalFilter = false
      const { path, query } = this.$route
      const defaultPeriod = this.setDefaultOrderPeriod()
      let parseQuery = { workspace_id: query.workspace_id }

      parseQuery.business_id = query?.business_id
        ? query.business_id
        : undefined
      parseQuery.business_id_sales = query?.business_id || !value.business.length
        ? undefined
        : value.business.join(',')
      
      if (path === '/sales') {
        parseQuery.channel_id = value.channel.length
          ? value.channel.join(',')
          : undefined
        parseQuery.sales_channel_id = value.sales_channel.length
          ? value.sales_channel.join(',')
          : undefined
      } else if (path !== '/sales' && query?.sales_channel_id) {
        parseQuery.sales_channel_id = query.sales_channel_id
      }

      parseQuery.warehouse_id = value.warehouse.length
        ? value.warehouse.join(',')
        : query?.warehouse_id && this.$store.state.user.restriction_base === 'Warehouse'
        ? query.warehouse_id
        : undefined
      parseQuery.order_type = value.order_type !== 'ALL'
        ? value.order_type
        : undefined
      parseQuery.priority_level = value.priority_level.length
        ? value.priority_level.join(',')
        : undefined
      parseQuery.status = value.status !== 'all'
        ? value.status
        : undefined
      parseQuery.customer_name = value.customer
        ? value.customer
        : undefined
      parseQuery.courier_name = value.courier
        ? value.courier
        : undefined
      
      if(!isEqual(defaultPeriod, value.date)) {
        parseQuery = {
          ...parseQuery,
          date_from: value.date.length
            ? this.$moment(value.date[0]).format()
            : undefined,
          date_until: value.date.length
            ? this.$moment(value.date[1]).format()
            : undefined,
        }
      }

      if (!isEqual(parseQuery, query)) {
        this.$router.push({
          query: {
            ...query,
            ...parseQuery,
            page: undefined,
          },
        }).catch(()=>{})
      }
    },
    resetFilter() {
      const { path, query } = this.$route
      let parseQuery = { workspace_id: query.workspace_id }

      if(query?.business_id) {
        parseQuery.business_id = query.business_id
      }

      if(query?.warehouse_id && this.$store.state.user.restriction_base === 'Warehouse') {
        parseQuery.warehouse_id = query.warehouse_id
      }

      
      if(path?.startsWith('/sales-channel')) {
        if(query?.channel_code) parseQuery.channel_code = query.channel_code
        if(query?.sales_channel_id) parseQuery.sales_channel_id = query.sales_channel_id
      }

      
      this.customerValue = ''
      this.courierValue = ''
      this.businessValue = []
      this.salesChannelValue = []
      this.channelValue = []
      this.warehouseValue = []
      this.orderTypeValue = 'ALL'
      this.priorityLevelValue = []
      this.statusValue = 'all'
      this.orderPeriod = this.setDefaultOrderPeriod() 

      if (!isEqual(parseQuery, query)) {
        this.$router.push({ query: parseQuery })
      }
    },
    removeFilter(item) {
      let query = {}
      if(item.name === 'date_from') {
        query = { date_from: undefined, date_until: undefined }
      } else if(item.name === 'sales_channel_id') {
        let channelTag = []
        let salesChannelTag = []
        if (this.$route.path === '/sales') {
          channelTag = this.$route.query.channel_id.split(',')
          salesChannelTag = !channelTag.length
            ? []
            : this.$route.query[item.name].split(',')
          const tagIndex = channelTag.findIndex(t => t == item.value)
          if (tagIndex > -1) {
            channelTag.splice(tagIndex, 1)
            salesChannelTag.splice(tagIndex, 1)
          }
        }
        query = {
          sales_channel_id: salesChannelTag.length ? salesChannelTag.join(',') : undefined,
          channel_id: channelTag.length ? channelTag.join(',') : undefined,
        }
      } else {
        const tag = this.$route.query[item.name].split(',')
        const filteredTag = tag.filter(t => t != item.value)
        query = { [item.name]: filteredTag.length ? filteredTag.join(',') : undefined }
      }
      this.$router.push({
        query: {
          ...this.$route.query,
          ...query,
        },
      }).catch(() => {})
    },
    changeCategorieState(state) {
      const { value, title, shipping_states } = state
      const UND = undefined
      this.$router.push({
        query: {
          ...this.$route.query,
          sales_state: value === 'all' || ['SHIPPED', 'DELIVERED'].includes(value) ? UND : value,
          shipping_states: ['SHIPPED', 'DELIVERED', 'ACCEPTED'].includes(value) ? (shipping_states === 'DELIVERED' ? `${shipping_states},BUYER_ACCEPTED` : shipping_states) : UND,
          filter_category: title,
          order_id: UND,
          page: UND,
        },
      })
    },
    changePage(page) {
      this.$router.push({ query: { ...this.$route.query, page } })
    },
    onShowModalFilter() {
      
      this.showModalFilter = true
    },
    resetRow() {
      this.salesData = []
      this.total = {
        all: 0,
        verified: 0,
        submitted: 0,
        cancelrequested: 0,
        onprocess: 0,
        shipped: 0,
        send: 0,
        completed: 0,
        canceled: 0,
      },
      this.total_row = 0
    },
    getData: debounce(async function() {
      const { path, query, params } = this.$route
      const {
        business_id,
        business_id_sales,
        sales_channel_id,
        channel_id,
        warehouse_id,
        order_type,
        priority_level,
        status,
        q,
        date_from,
        date_until,
        customer_name,
        courier_name,
        ...restQuery
      } = query 

      this.loadingList = true
      this.loadingCategory = true
      this.errorRows = false
      this.querySearch = q || ''
      this.showModalFilter = false 

      this.total_row = 0
      this.total = {
        all: 0,
        verified: 0,
        submitted: 0,
        cancelrequested: 0,
        onprocess: 0,
        shipped: 0,
        send: 0,
        completed: 0,
        canceled: 0,
      }

      if (date_from === 'all' && date_until === 'all') {
        this.orderPeriod = ['all', 'all']
      } else {
        
        this.orderPeriod =
          date_from && date_until
            ? [
                this.$moment(date_from).format(),
                this.$moment(date_until).format(),
              ]
            : this.setDefaultOrderPeriod()
        
      }

      this.businessValue = business_id_sales ? business_id_sales.split(',') : []
      this.salesChannelValue = path === '/sales' && sales_channel_id ? sales_channel_id.split(',').map(v => String(v)) : []
      this.channelValue = path === '/sales' && channel_id ? channel_id.split(',').map(v => String(v)) : []
        

      this.warehouseValue = warehouse_id ? warehouse_id.split(',') : []
      this.orderTypeValue = order_type ? order_type : 'ALL'
      this.priorityLevelValue = priority_level ? priority_level.split(',') : []
      this.statusValue = status ? status : 'all'
      this.customerValue = customer_name || ''
      this.courierValue = courier_name || ''

      
      if (business_id && business_id_sales) {
        this.$router.replace({ query: { ...query, business_id_sales: undefined } }) 
      }

      this.controller = new AbortController()

      let salesChannelId = sales_channel_id
      let channelId = +params.id || undefined

      let salesChannelParams = {}
      if (path === '/sales') {
        channelId = channel_id
      } else {
        const findSalesChannel = this.options_channel.find(item => String(item.value) === channel_id)
        if (findSalesChannel) {
          channelId = channel_id
          salesChannelParams.channel_code = findSalesChannel.channelCode
        }
      }
      if (this.listChannels?.id && path?.startsWith('/redeem-channel') && +params.id !== this.listChannels.id) {
        salesChannelId = this.listChannels.sales_channel.id
        channelId = this.listChannels.id
      }

      const bodyReq = {
        ...restQuery,
        ...salesChannelParams,
        business_id: business_id || business_id_sales || this.businessId,
        page: this.currentPage,
        limit: this.PAGE_SIZE,
        sort_mode: this.sort_mode,
        sales_channel_id: salesChannelId,
        warehouse_id,
        channel_id: channelId,
        order_type: order_type && order_type !== 'ALL'
          ? order_type
          : undefined,
        fulfillment_priority_level: priority_level,
        confirmed: status === 'confirmed'
          ? true
          : status === 'unconfirmed'
          ? false
          : undefined,
        q,
        date_from: this.$moment(this.orderPeriod[0]).utc().toISOString(),
        date_until: this.$moment(this.orderPeriod[1]).utc().toISOString(),
        customer_name,
        courier_name,
      }

      await getSalesView({
        signal: this.controller.signal,
        params: bodyReq,
      })
      .then(({ data: resSales }) => {
        if (resSales) {
          let orderIds = []
          const { data } = resSales
          this.orderLength = 0

          this.salesData = data && data.length
            ? data.map(d => {
                orderIds.push(d.id)

                d.business = this.$store.state.user.businessList.find(business => business.business_id === d.business_id)
                const findChannel = this.allChannelList.find(channel => channel.id == d?.channel_id)
                d.channel = findChannel?.id
                  ? {
                      ...findChannel,
                      business_id: d.business_id,
                      code: findChannel?.sales_channel?.code,
                      name: findChannel?.title,
                    }
                  : {}

                this.orderLength = d.order_number && d.order_number.length > this.orderLength
                  ? d.order_number.length
                  : this.orderLength
                if(this.$route.meta.key.includes('sales-channel-kino')) {
                  d.sfa = {
                    order_id: '',
                    created_at: '',
                    response: '',
                    response_body: '',
                    response_code: '',
                  }
                }
                return d
              })
            : []
            
            this.getDataTotal(bodyReq)
            
            if(this.$route.meta.key.includes('sales-channel-kino')) {
            this.fetchKinoSfa(orderIds.join())
          }
        } else {
          this.resetRow()
        }
      })
      .catch(err => {
        if (err?.code !== 'ERR_CANCELED') {
          this.errorRows = err.response.status
          this.resetRow()
        }
      })
      .finally(() => {
        if (path === '/sales' && this.loadChannel && sales_channel_id) {
          this.fetchChannel()
        }

        
        if (this.loadWarehouse && warehouse_id) {
          this.fetchWarehouse()
        }

        this.controller = null
        this.loadingList = false
      })
    }, 500),
    async getDataTotal(bodyReq) {
      this.controllerTotal = new AbortController()
      await getSalesTotal({
        signal: this.controllerTotal.signal,
        params: bodyReq,
      })
      .then(({ data }) => {
        if (data?.length) {
          data.forEach(d => {
            if (d.state === 'VERIFIED') {
              this.total.verified += d.total
              this.total.all += d.total
            } else if (d.state === 'SUBMITTED') {
              this.total.submitted += d.total
              this.total.all += d.total
            } else if (d.state === 'ACCEPTED') {
              if (d.shipping === 'SHIPPED') {
                this.total.shipped += d.total
              this.total.all += d.total
              } else if (d.shipping === 'CREATED' || d.shipping === 'BOOKED') {
                this.total.onprocess += d.total
              this.total.all += d.total
              } else if (d.shipping === 'DELIVERED' || d.shipping === 'BUYER_ACCEPTED') {
                this.total.send += d.total
              this.total.all += d.total
              }
            } else if (d.state === 'COMPLETED') {
              this.total.completed += d.total
              this.total.all += d.total
            } else if (d.state === 'CANCELREQUESTED' || d.state === 'CANCEL_REQUESTED') {
              this.total.cancelrequested += d.total
              this.total.all += d.total
            } else if (d.state === 'CANCELED' || d.state === 'CANCELEDPAYMENTEXPIRED' || d.state === 'REJECTED') {
              this.total.canceled += d.total
              this.total.all += d.total
            }
          })
        }
      })
      .finally(() => {
        this.total_row = this.total[this.activeCategories] || 0
        this.controllerTotal = null
        this.loadingCategory = false
      })
    },
    async fetchKinoSfa(orderIds) {
      this.total_box = 0
      await getKinoSfa({ orderIds })
        .then(({ data: { data: response } }) => {
          response?.forEach(sfa => {
            const index = this.salesData.findIndex(sales => sales.id === sfa.order_id)
            if(index > -1) {
              this.salesData[index].sfa = sfa
              if(sfa.response == '0') {
                this.salesData[index].submitted = false
                this.total_box++
              }
            }
          })
        })
    },
    blurChannel() {
      if (!this.options_channel.length && !this.loadChannel) {
        this.loadChannel = true
      }
    },
    fetchChannel: debounce(async function() {
      if (this.loadChannel) {
        const { business_id } = this.$route.query
        await this.$store
          .dispatch('channel/GETSALESCHANNEL', { business_id: business_id || this.businessId })
          .then(() => {
          })
          .catch(err => {
            this.$message.error(err.message)
            document.activeElement.blur()
          })
          .finally(() => {
            this.loadChannel = false
          })
      }
    }, 500),
    onBlurWarehouse() {
      
      if (!this.warehouse_list.length && !this.loadWarehouse) {
        this.loadWarehouse = true
      }
    },
    fetchWarehouse: debounce(async function() {
      if (this.loadWarehouse) {
        const { business_id } = this.$route.query
        const params = { business_id: business_id || this.businessId }
        
        try {
          this.warehouse_list = await getAllWarehouseList(params)
        } catch (err) {
          this.$message.error(err.message)
          document.activeElement.blur()
        } finally {
          this.loadWarehouse = false
        }
      }
    }, 500),
    async onOpenCollapse(item) {
      await this.fetchWarehouse()
      this.salesData.forEach(f => {
        if (f.id === item.id) {
          
          const nameWarehouse = this.warehouse_list.find(f => f.id === item.warehouse_id)
          if (nameWarehouse) {
            item.warehouseName = nameWarehouse.name
            item.warehouseAddress = nameWarehouse.address
          } else {
            item.warehouseName = '-'
          }
        }
      })
    },
    checkboxSelectAllSubmitted(event) {
      this.checked_all = event.target.checked
      this.salesData.forEach((item, index) => {
        if(this.$route.meta.key.includes('sales-channel-kino') && item?.sfa?.response == '0') {
          this.handleItemSubmitted({
            index,
            checked: event.target.checked,
            id: item.id,
          })
        }
      })
    },
    handleSfaDetail(value) {
      this.sfaInfo = {
        visible: true,
        order_number: value.order_number,
        description: value.response_body,
      }
    },
    handleItemSubmitted(obj) {
      this.salesData[obj.index].submitted = obj.checked
      const index = this.tempSales.findIndex(sales => sales === obj.id)
      if(obj.checked && index < 0) {
        this.tempSales.push(obj.id)
      } else if(!obj.checked && index > -1) {
        this.tempSales.splice(index, 1)
      }
      
      this.indeterminate = this.tempSales.length > 0 && this.tempSales.length < this.total_box
      this.checked_all = this.tempSales.length == this.total_box
    },
    async handleSubmitSFA() {
      this.loadingList = true
      this.loadingCategory = true
      await resendKinoSfa({
        business_id: this.businessId,
        data: { order_ids: this.tempSales },
      })
      .then(() => this.finishSubmitSFA('success', ''))
      .catch(err => this.finishSubmitSFA('failed', err?.response?.data?.message || ''))
    },
    finishSubmitSFA: debounce(function(status, description) {
      const type = status === 'failed' ? 'error' : 'success'
      this.$notification[type]({
        message: `Resend SFA ${this.$t(`utils.${status}`)}`,
        description,
      })
      if(status === 'success') {
        this.indeterminate = false
        this.checked_all = false
        this.tempSales = []
        this.getData()
      } else {
        this.loadingList = false
        this.loadingCategory = false
      }
    },5000),
    refreshPage() {
      window.location.reload()
    },
    onSyncOrderForChannel(payload) {
      this.loadingSyncOrder = true
      const { query, params } = this.$route
      if (['shopee_id', 'lazada_id'].includes(query.channel_code)) {
        onSyncOrderChannel({
          business_id: query.business_id,
          channel_id: params.id,
          channel_code: query.channel_code,
          payload: payload,
        })
        .then(() => {
          let checkTimes = 0
          const interval = setInterval(async () => {
            checkTimes +=1
            const { data: dataCheck } = await checkStatusSyncOrderChannel({
              business_id: query.business_id,
              channel_id: params.id,
              channel_code: query.channel_code,
            })
            if (dataCheck?.data?.status === "COMPLETED") {
              clearInterval(interval)
              this.$notification.success({
                message: 'Berhasil Sync Order',
                description: 'Halaman akan otomatis direfresh saat notification ini hilang',
                onClose: () => this.refreshPage(),
                duration: 3,
              })
              this.loadingSyncOrder = false
              this.onCloseModalSyncOrderChannel()
              setTimeout(() => this.refreshPage(), 3000)
            } else if (checkTimes > 9) {
              clearInterval(interval)
              this.$notification.success({
                message: 'Sync Order anda dalam proses',
                description: 'Maaf, harap menunggu sebentar. permintaan sync order anda dalam proses',
              })
              this.loadingSyncOrder = false
              this.onCloseModalSyncOrderChannel()
            }
          }, 2000)
        })
        .catch(error => {
          const errorRes = error?.response?.data
          this.$notification.error({
            message: 'Terjadi Kesalahan',
            description: errorRes ? `${errorRes.error}, ${errorRes.status} - ${errorRes.message}` : 'Internal Server Error',
          })
          this.loadingSyncOrder = false
          this.onCloseModalSyncOrderChannel()
        })
      } else if (['tokopedia_id', 'tiktok'].includes(query.channel_code)) {
        onSyncOrderChannel({
          business_id: query.business_id,
          channel_id: params.id,
          channel_code: query.channel_code,
          payload: payload,
        })
        .then(({ status, data }) => {
          this.loadingSyncOrder = false
          this.onCloseModalSyncOrderChannel()
          if ([200, 202].includes(status)) {
            this.$notification.success({
              message: 'Berhasil Sync Order',
              description: 'Halaman akan otomatis direfresh saat notification ini hilang',
              onClose: () => this.refreshPage(),
              duration: 3,
            })
            setTimeout(() => this.refreshPage(), 3000)
          } else {
            this.$notification.error({
              message: 'Terjadi Kesalahan',
              description: data?.message || 'Gagal saat melakukan sync order.',
            })
          }
        })
        .catch(error => {
          const errorRes = error?.response?.data
          this.$notification.error({
            message: 'Terjadi Kesalahan',
            description: errorRes ? `${errorRes.error}, ${errorRes.status} - ${errorRes.message}` : 'Internal Server Error',
          })
          this.loadingSyncOrder = false
          this.onCloseModalSyncOrderChannel()
        })
      }
    },
    onSetList(value) {
      const listName = value.type === 'salesChannel'
        ? 'salesChannelList'
        : value.type === 'channel'
        ? 'channelList'
        : 'warehouseList'
      this[listName] = value.list
    },
  },
}
</script>

<style lang="scss" scoped>
.row-calc > .col {
  padding-left: 9px;
  padding-right: 9px;
  flex-basis: calc(100% / 6); 
  max-width: calc(100% / 6);
  font-size: 13px;
}

.col-10p {
  flex-basis: 10%;
  max-width: 10%;
  font-size: 13px;
}

.salesindex {
  font-family: 'Poppins', sans-serif !important;
  font-style: normal;

  .categories {
    .list {
      color: #999;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 2px 14px;
      min-height: 30px;
      background: #fff;
    }

    .list:not(:focus) {
      border-color: #999;
    }

    .active {
      background: #4d4d4d;
      color: #fff;
      border-color: #4d4d4d;
    }

    .list:hover:not(.active) {
      border-color: #4d4d4d;
      color: #4d4d4d;
    }
  }

  .active {
    background: #0559cb;
    color: #fff;
    border: 1px solid #0559cb;
  }
}
</style>

<style lang="scss">
.skeleton-total-sales ul {
  margin: 0;
}
.skeleton-total-sales li {
  height: 18px !important;
  border: 1px solid #ddd;
}
.w-8 {
  flex-basis: 4% !important;
  max-width: 4% !important;
  -ms-flex-preferred-size: 4% !important;
}
.fulfillment-checkbox .ant-checkbox-inner {
  border-color: #999 !important;
}
.filter-tag {
  padding: 4px 8px !important;
  font-size: 11px !important;
  background: #e8e8e8 !important;
  border-radius: 16px !important;

  i {
    font-size: 14px !important;
  }
}

.log-timeline .log-current {
  color: #f5222e;
}
.log-timeline .ant-timeline-item-head-red {
  background-color: #f5222e !important;
}
.log-timeline .ant-timeline-item-head-gray {
  background-color: #c8c4db !important;
}
.log-modal .ant-modal-body {
  max-height: 600px;
  overflow-y: auto;
}
</style>
